import {createTheme} from './createThemeUtil';
import {TMNAPalette} from './themeOverrides';

export const tmnaTheme = createTheme({
    palette: TMNAPalette as any,
    fontFamily: 'ToyotaType',
    defaultPageTheme: 'home',
});
